import { render, staticRenderFns } from "./list.vue?vue&type=template&id=4864822d&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4864822d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4864822d')) {
      api.createRecord('4864822d', component.options)
    } else {
      api.reload('4864822d', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=4864822d&scoped=true", function () {
      api.rerender('4864822d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/departedManagement/list.vue"
export default component.exports